import React, {useState} from 'react';
import {Button, Stack, TextField, Typography} from '@mui/material';
const _awpBase = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/;

const RequestAccessForm = ({embedded = false}) => {
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const isValid = emailRegex.test(email);

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!isValid || submitting) return;
        setSubmitting(true);
        try {
            const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            await fetch(`${_awpBase}/api/documents/trial_requests/${id}`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email: email.trim().toLowerCase(), createdAt: new Date().toISOString(), status: 'pending', source: 'login'}),
            });
            setSubmitted(true);
        } catch (err) {
            // Requirement: if error log error
            console.error('RequestAccessForm submission error', err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Stack
            p={embedded ? 0 : 3}
            pt={embedded ? 0 : 4}
            width={embedded ? '100%' : 665}
            borderRadius={embedded ? 0 : 2}
            sx={{
                position: 'relative',
                ...(!embedded && {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: 8,
                        background: 'linear-gradient(90deg, #7C4DFF 0%, #00C6FF 100%)',
                    },
                }),
            }}
            bgcolor={embedded ? 'transparent' : 'white'}
            boxShadow={embedded ? 0 : 1}
            alignItems="center"
        >

            {submitted ?
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    p={embedded ? 3 : 0}
                    textAlign="center"
                >
                    <Typography fontWeight={600} variant="body1" color="success.main">
                        Thank you! You will be notified when your request has been approved.
                    </Typography>
                </Stack>
                :
                <Stack
                    width={'100%'}
                    spacing={2}
                    direction={embedded ? 'column' : 'row'}
                    alignItems={embedded ? 'stretch' : 'center'}
                >
                    <TextField
                        label="Email Address"
                        placeholder="Enter your email"
                        type="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        size={embedded ? "medium" : "small"}
                        required
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && isValid) {
                                handleSubmit();
                            }
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth={embedded}
                        size={embedded ? "large" : "medium"}
                        disabled={!isValid || submitting}
                        onClick={handleSubmit}
                        sx={{
                            flexShrink: 0,
                            ...(embedded && {
                                minHeight: 48,
                                textTransform: 'none',
                                fontWeight: 600,
                            }),
                        }}
                    >
                        {submitting ? 'Submitting…' : 'Request Access'}
                    </Button>
                </Stack>
            }
        </Stack>
    );
};

export default RequestAccessForm;

